import { ff } from '@atlassian/jira-feature-flagging';

// <aakeroyd>
export const isStatusInGicEnabled = () => ff('issue.details.gic.add_status_field', false);
// </aakeroyd>

// <rkarki>
export const TABULAR_GRID_FIELDS = 'jsw.uif.tmp.card.tabular.grid';
export const isTabularGridFieldsEnabled = () => ff(TABULAR_GRID_FIELDS, false);
// </rkarki>

// <bento>
export const isWorkflowDataServiceHookEnabled = () =>
	ff('use-view-workflow-service-hook_8y6bk', false);
// </bento>
